<script setup lang="ts">
  import { computed } from 'vue'
  import { randomId } from '@/functions'

  const props = defineProps<{
    id?: string,
    label?: string,
    placeholder?: string,
    required?: boolean,
    error?: string | string[],
    disabled?: boolean,
    modelValue?: string | null,
  }>()

  const emit = defineEmits<{
    (e: 'update:modelValue', value?: string): void,
  }>()

  const model = computed({
    set: (val) => {
      // empty string emit undefined
      emit('update:modelValue', val)
    },
    get: () => props.modelValue ?? '',
  })

  const defaultId = randomId()
  const inputId = computed(() => props.id ?? 'text-' + defaultId)
</script>

<template>
  <div class="relative">
    <app-input
      :id="inputId"
      v-model="model"
      :label="label"
      :error="error"
      :required="required"
      type="time"
      class="min-w-32"
      :placeholder="placeholder">
      <template #inline>
        <!-- <div
          class="datepicker-icon"
          :class="{
            'text-gray-300': disabled,
          }">
          <fa-icon icon="i-far-clock" />
        </div> -->
      </template>
    </app-input>
  </div>
</template>

<style lang="postcss" scoped>
  :deep() {
    input[type="time"]::-webkit-calendar-picker-indicator {
      display: none;
    }
  }
  .datepicker-icon {
    @apply absolute bottom-0 flex items-center text-sm leading-0 pr-2 right-0 pointer-events-none;
    @apply text-gray;
    @apply h-9; /* height of form-input */
  }
</style>
